import React, { useState, useEffect, createRef } from 'react';
import PropTypes from 'prop-types';
import { Collapse, Upload, Spin, Icon, Progress, message } from 'antd';
import _ from 'lodash';
import { fetchVoiceFilesTranscription } from '../../api/demonstration';
import less from './VoiceFilesTranscription.less';
import './VoiceFilesTranscription.css';
import account from '@/common/account/index';

const { Panel } = Collapse;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const audioPlayBtn =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/assets/images/audioPlay.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=5190735621&Signature=z14TfDkLacKi6WbyG25J%2FZKTfxk%3D';
const audioPauseBtn =
  'https://openplantform.oss-cn-beijing.aliyuncs.com/assets/images/audioPause.png?OSSAccessKeyId=LTAI4FvBYgUM9wyFK4wa9nvy&Expires=5190735712&Signature=Bv0NMH4AndoJQpUh7wq5tYMG3ng%3D';

const VoiceFilesTranscription = ({ materials }) => {
  const [requestStatus, setRequestStatus] = useState('requesting');
  const [activeAudioPanel, setActiveAudioPanel] = useState('0');
  const [currentAudioBtn, setCurrentAudioBtn] = useState('0');
  const [audioFile, setAudioFile] = useState(null);
  const [progressList, setProgressList] = useState(
    new Array(materials.length).fill(0)
  );
  const [textList, setTextList] = useState(
    new Array(materials.length).fill('')
  );
  const [audioList, setAudioList] = useState(() => {
    return materials.map((v) => {
      v.ref = createRef();
      return v;
    });
  });
  const uploadProps = {
    supportServerRender: true,
    accept: 'video/mp4, audio/mp3, audio/x-m4a, audio/wav',
    name: 'file',
    showUploadList: false,
    beforeUpload: (file) => {
      const { size } = file;
      const fileUrl = URL.createObjectURL(file);
      const audioElement = new Audio(fileUrl);
      audioElement.addEventListener('loadedmetadata', () => {
        if (size > 10000000) {
          message.error('您的语音文件过大，请选择小于10M的文件');
        } else {
          const cAudioList = _.cloneDeep(audioList);
          const cProgressList = _.cloneDeep(progressList);
          const cTextList = _.cloneDeep(textList);
          if (cAudioList.length >= 3) {
            cAudioList.splice(3, 1);
            cProgressList.splice(3, 1);
            cTextList.splice(3, 1);
          }
          cAudioList.push({
            title: file.name,
            url: fileUrl,
            index: '3',
            isPausing: true,
            ref: createRef(),
            playTimer: null
          });
          cProgressList.push(0);
          setProgressList(cProgressList);
          cTextList.push('');
          setTextList(cTextList);
          setAudioList(cAudioList);
          setActiveAudioPanel('3');
          setAudioFile(file);
          setRequestStatus('requesting');
        }
      });
      return false;
    }
  };
  const fetchTranscriptionRes = () => {
    const fd = new FormData();
    if (activeAudioPanel === '3') {
      fd.append('file', audioFile);
    } else {
      fd.append('url', audioList[activeAudioPanel].url);
    }
    let userId = null;
    const loginEd = account.hasLoggedin();
    if (loginEd) userId = localStorage.getItem('userId') || null;
    fd.append('userId', userId);
    fetchVoiceFilesTranscription(fd)
      .then((res) => {
        const cTextList = _.cloneDeep(textList);
        let resText = '';
        if (!Array.isArray(res.result.result)) {
          throw new Error('Bad response.');
        }
        res.result.result.forEach((v) => {
          resText += v.text;
        });
        cTextList[activeAudioPanel] = resText;
        setTextList(cTextList);
        setRequestStatus('requestDone');
      })
      .catch((err) => {
        message.error(err.msg || '语音文件转录失败!');
        setRequestStatus('requestDone');
      });
  };

  const handleChangePanel = (index) => {
    if (!index) {
      return;
    }
    setActiveAudioPanel(index);
    const cTextList = _.cloneDeep(textList);
    cTextList[index] = '';
    setTextList(cTextList);
    setRequestStatus('requesting');
  };
  const handleProgress = () => {
    const cAudioList = _.cloneDeep(audioList);
    const currentDom = cAudioList[currentAudioBtn].ref.current;
    if (cAudioList[currentAudioBtn].isPausing) {
      currentDom.pause();
    } else {
      currentDom.play();
      cAudioList[currentAudioBtn].playTimer = setInterval(() => {
        if (currentDom.paused) {
          clearInterval(cAudioList[currentAudioBtn].playTimer);
          if (
            Math.floor(currentDom.currentTime) >=
            Math.floor(currentDom.duration)
          ) {
            cAudioList[currentAudioBtn].isPausing = true;
            setAudioList(cAudioList);
          }
        }
        const cProgressList = _.cloneDeep(progressList);
        // eslint-disable-next-line max-len
        cProgressList[currentAudioBtn] = Math.floor(
          (currentDom.currentTime / currentDom.duration) * 100
        );
        setProgressList(cProgressList);
      }, 300);
    }
  };
  const handleAudioControl = (index) => {
    setCurrentAudioBtn(index);
    const cAudioList = _.cloneDeep(audioList);
    cAudioList.forEach((item) => {
      if (item.index != index) {
        item.isPausing = true;
        item.ref.current.pause();
      }
    });
    cAudioList[index].isPausing = !cAudioList[index].isPausing;
    setAudioList(cAudioList);
  };
  const customHead = (audio, index) => {
    return (
      <>
        <img
          onClick={(e) => {
            e.stopPropagation();
            handleAudioControl(index);
          }}
          src={audio.isPausing ? audioPlayBtn : audioPauseBtn}
          alt="play"
        />
        <span>{audio.title}</span>
        <audio src={audio.url} ref={audio.ref} />
        <Progress
          percent={progressList[index]}
          showInfo={false}
          strokeWidth={3}
          strokeLinecap="square"
          size="small"
          strokeColor="#89ADE2"
        />
      </>
    );
  };
  useEffect(() => {
    if (requestStatus === 'requesting') {
      fetchTranscriptionRes();
    }
  }, [requestStatus]);
  useEffect(() => {
    handleProgress();
  }, [audioList]);

  return (
    <>
      <div className={less.functionBox} id="functionBox">
        <div className={less.title}>
          中文-老师
          <span className={less.bottomLine} />
        </div>
        <Spin
          indicator={antIcon}
          spinning={requestStatus === 'requesting'}
          tip="识别中"
        >
          <Collapse
            accordion
            bordered={false}
            onChange={handleChangePanel}
            activeKey={activeAudioPanel}
            className={less.audioCustomCollapse}
          >
            {audioList.map((audio, index) => {
              return (
                <Panel
                  header={customHead(audio, index)}
                  key={audio.index}
                  forceRender
                  showArrow={false}
                  className={less.audioCustomPanel}
                >
                  <p className={less.audioTranstionResponse}>
                    {textList[index]}
                  </p>
                </Panel>
              );
            })}
          </Collapse>
          <p className={less.audioTips}>
            当前为
            <span className={less.audioTipsHighlight}>中文</span>
            语音识别，适用于
            <span className={less.audioTipsHighlight}>老师教学场景</span>
          </p>
          <Upload {...uploadProps} className="upload_file">
            <div
              className={less.fileUploadBtn}
              onClick={() => {
                const loginEd = account.hasLoggedin();
                if (!loginEd) {
                  window.location.href = `/account/login?from=${window.location.pathname}${window.location.search}`;
                }
              }}
            >
              上传本地文件
            </div>
          </Upload>
          <span className={less.fileTypeTips}>
            文件类型支持mp4，mp3，m4a，wav格式，文件大小不能超过10M
          </span>
        </Spin>
      </div>
    </>
  );
};

VoiceFilesTranscription.propTypes = {
  data: PropTypes.shape({
    materials: PropTypes.array
  })
};

export default VoiceFilesTranscription;
